exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Cn4YAtPSXkIKjR9ufrWfn{text-align:center}._1dgXccUUpeM5miPQAcE06q{text-align:center}._1dgXccUUpeM5miPQAcE06q img{max-width:100%;max-height:675px;margin:0 auto}._2L-X6tzQYObl8gOemNFyL1{text-align:center;height:80vh;max-height:600px;overflow:hidden;display:flex;justify-content:center;align-items:center;position:relative}._2L-X6tzQYObl8gOemNFyL1 img{width:100%;height:auto;margin:0 0;flex:0 0 100%}.A5k-Ta7ra33DBWRf-xUzm{text-align:center;font-style:italic;color:#666}@media screen and (max-width: 500px){._1dgXccUUpeM5miPQAcE06q img{max-height:400px}._2L-X6tzQYObl8gOemNFyL1{max-height:400px}}\n", ""]);

// Exports
exports.locals = {
	"GalleryViewer": "_2Cn4YAtPSXkIKjR9ufrWfn",
	"singleImg": "_1dgXccUUpeM5miPQAcE06q",
	"singleImgBig": "_2L-X6tzQYObl8gOemNFyL1",
	"caption": "A5k-Ta7ra33DBWRf-xUzm"
};